import * as actionTypes from '../actions/actionTypes';
import { updateEquipmentPodName } from '../actions';
import {
  updateObject
} from '../../shared/utility';
import { EquipmentTypes } from '../../shared/common';

const initialState = {
  equipmentList: [],
  account: null,
  equipment: null,
  error: false,
  success: false,
  loading: false,
  loaded: false,
  realEquipment: {
    claimedPods:[],
    unclaimedPods:[],
    pods:[],
    modems:[],
    routers:[]
  },
  selectedEquipment: {
    displayAllEquipment: true,
    type: EquipmentTypes.Equipment
  },
  locatePodDisplayLED:false,
  locatePodSuccess:false,
  locatePodError:false,
  locatePodId:''

};
const resetEquipmentState = (state, action) => {
  return updateObject(state, initialState)
}
const initEquipmentStart = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: true,
    loaded: false
  });
};

const setEquipment = (state, action) => {
  return updateObject(state, {
    realEquipment: action.realEquipment,
    loading: false,
    loaded: true,
    added: false,
    edited: false
  });
};

const fetchEquipmentFailed = (state, action) => {
  return updateObject(state, {
    loading: false,
    loaded: true,
    error: true,
    success: false
  });
};
const fetchEquipmentSuccess = (state, action) => {
  return updateObject(state, {
    loading: true,
    loaded: true,
    error: false,
    success: true
  });
};

const changePodFailed = (state, action) => {
  return updateObject(state, {
    error: true,
    success: false
  });
};

const changePodSuccess = (state, action) => {
  const selectedEquipment = Object.assign({}, state.selectedEquipment);
  selectedEquipment.nickname = action.nickname;
  return updateObject(state, {
    success: true,
    error: false,
    selectedEquipment
  });
};

const resetEquipmentErrorSuccess = (state, action) => {
  return updateObject(state, {
    success: false,
    error: false
  });
};

const initSelectedEquipment = (state, action) => {
  return updateObject(state, {
  });
};

const setSelectedEquipment = (state, action) => {
// console.log('is there equip', action.selectedEquipment)
    return updateObject(state, {
      selectedEquipment: action.selectedEquipment ? action.selectedEquipment : {
        displayAllEquipment: true,
        type: EquipmentTypes.Equipment
      },
      loading: false,
      loaded: true,
      error: false,
      success: false
    });
  
  
};

const updateLocatePod = (state, action) => {
  // console.log('state Object :::', state,action);
  return updateObject(state, {
    locatePodDisplayLED: action.updateLocatePod,
    locatePodId:state.selectedEquipment.podId
   
  });
};

const locatePodSuccess = (state, action) => {
  return updateObject(state, {
    locatePodSuccess: false,
    locatePodError: false
  });
};

const locatePodFailed = (state, action) => {
  return updateObject(state, {
    locatePodSuccess: false,
    locatePodError: false
  });
};

const updateEquipmentPodNickName = (state, action) => {
  const claimedPods = state.realEquipment.claimedPods.map(pod => {
    if (pod.id === action.data.pSerial) return { ...pod, nickname: action.data.nickName };
    return pod;
  });
  return updateObject(state, {
    realEquipment: {
      ...state.realEquipment,
      claimedPods
    }
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INIT_EQUIPMENT_START:
      return initEquipmentStart(state, action);
    case actionTypes.SET_EQUIPMENT:
      return setEquipment(state, action);
    case actionTypes.FETCH_EQUIPMENT_FAILED:
      return fetchEquipmentFailed(state, action);
    case actionTypes.FETCH_EQUIPMENT_SUCCESS:
      return fetchEquipmentSuccess(state, action);
    case actionTypes.RESET_EQUIPMENT_ERROR_SUCCESS:
      return resetEquipmentErrorSuccess(state, action);
    case actionTypes.INIT_SELECTED_EQUIPMENT:
      return initSelectedEquipment(state, action);
    case actionTypes.SET_SELECTED_EQUIPMENT:
      return setSelectedEquipment(state, action);
    case actionTypes.CHANGE_POD_FAILED:
      return changePodFailed(state, action);
    case actionTypes.CHANGE_POD_SUCCESS:
      return changePodSuccess(state, action);
    case actionTypes.LOCATE_POD_SUCCESS:
        return locatePodSuccess(state, action);
    case actionTypes.LOCATE_POD_FAILED:
      return locatePodFailed(state, action);
    case actionTypes.UPDATE_LOCATE_POD:
      return updateLocatePod(state, action);
    case actionTypes.UPDATE_POD_NAME:
      return updateEquipmentPodNickName(state, action);
    default:
      return state;
  }
};

export default reducer;
